export enum AgencyPhoneTypes {
  Mobile = 'Mobile',
  Landline = 'Landline',
}
